<template>
	<v3AnnouncementBanner />
	<LoadFeaturePermissions v-if="user.isLoggedIn" />
	<maintenanceBanner />
	<Notification />
	<Toast position="top-center" style="width: 500px" class="text-center" />

	<div id="app">
		<section v-if="user.isLoggedIn && !loginAnimation" id="sideBar">
			<!-- <sideBar
				v-if="(user.isLoggedIn && on_boarding) || (user.hasAccess('super_admin') == true) || (selectedProjectPlan?.plan == 'AGENCY')" /> -->
			<sideBar />
		</section>
		<section id="main">
			<suspense v-if="user.isLoggedIn">
				<topMenu />
				<template #fallback>
					<TopMenuSkeletton />
				</template>
			</suspense>
			<RouterView />
		</section>
	</div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
import sideBar from './components/utilities/layout/sideBar.vue';
import TopMenuSkeletton from './components/utilities/layout/topMenuSkeletton.vue';
import topMenu from './components/utilities/layout/topMenu.vue';
import Notification from '@/components/shared/Notification.vue';

import Toast from 'primevue/toast';
import './newrelic';

import LoadFeaturePermissions from '@/components/utilities/loads/loadFeaturePermissions.vue';
import maintenanceBanner from '@/components/utilities/layout/maintenanceBanner.vue';
import v3AnnouncementBanner from '@/components/utilities/layout/v3AnnouncementBanner.vue';
import kickOffView from '@/views/kick-off/kickOffView.vue';

import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/global/auth';
import { useBetaStore } from '@/store/global_settings/beta';
import { useMarketStore } from '@/store/global/market';
import { useProfileStore } from '@/store/global/profile.js';

const betaStore = useBetaStore();
const marketStore = useMarketStore();
const profile = useProfileStore();
const user = useAuthStore();
const { selectedProjectPlan } = storeToRefs(betaStore);
const { projects, selectedProject, markets, selectedMarket, on_boarding } = storeToRefs(marketStore);

const { access, loginAnimation } = storeToRefs(user);
const { user_name, user_image } = storeToRefs(profile);

window.dataLayer = window.dataLayer || [];

const route = useRoute();
const router = useRouter();
const path = ref(window.location.pathname);
newrelic.addPageAction('pageViewed', { page: path });

function getItemById(items, id) {
	return items.find(item => item.id === id) || null;
}

const selectedProjectItem = computed(() => getItemById(projects.value, selectedProject.value));
const selectedMarketItem = computed(() => getItemById(markets.value, selectedMarket.value));
const isProjectPaused = computed(() => selectedProjectItem.value?.type === 'paused');
const isMarketPaused = computed(() => selectedMarketItem.value?.type === 'paused');

watch([isProjectPaused, isMarketPaused], ([projectPaused, marketPaused]) => {
	if ((projectPaused || marketPaused) && route.path !== '/') {
		router.push('/');
	}
});

watch(() => route.path, newPath => {

	path.value = newPath;
}, { immediate: true });

onMounted(() => {
	loginAnimation.value = false;
});

</script>

<style lang="scss" scoped>
#app {
	display: flex;
	min-width: 98vw;
	max-width: 100%;
	min-height: 100vh;
	background-color: var(--beige-100);
}

#sideBar {
	width: 5%;
	min-width: 100px;
	min-height: 100vh;
}

#main {
	margin-right: 2rem;
	width: 92%;
}
</style>
<style lang="scss">
html, body {
	overflow-x: hidden;
	max-width: 100vw;
}

.no-scroll {
	overflow: hidden;
}
</style>